import React from 'react';
import { ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
interface Bubble {
  self: boolean;
  text: string;
  time: string;
}
const bubbles: Bubble[] = [{
  self: true,
  time: '8:15:07 PM',
  text: 'Hi Sam, this is the Ramirez Group about the East Cactus listing you just asked about. Are you looking to see it in person?'
}, {
  self: false,
  time: '8:16 PM',
  text: 'Yes, this weekend if possible. We are pre-approved up to 750.'
}, {
  self: true,
  time: '8:16 PM',
  text: 'Would Saturday at 10 or 11:30 work better for a tour?'
}];
export function SmsVignette() {
  return <VignetteFrame label="Text thread" timestamp="Sam T." data-id="element-388" data-mp="8m6s53f43rto">
      <Reveal className="rounded-xl border border-white/10 bg-ink-700 px-4 py-3" data-id="element-389" data-mp="8nq9kxci88x1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/40" data-id="element-390" data-mp="3895831ux7vra">
          New portal lead received
        </p>
        <p className="mt-1 text-sm font-semibold tabular-nums text-white/70" data-id="element-391" data-mp="3c95sd34pb169">8:14:22 PM</p>
      </Reveal>

      <Reveal delay={0.2} className="mt-3 flex items-center gap-2 pl-1 text-xs font-semibold text-brand" data-id="element-392" data-mp="23984anu8d5zk">
        <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-393" data-mp="1yhq4w47uvdgp" />
        45 seconds
      </Reveal>

      <div className="mt-3 space-y-3" data-id="element-394" data-mp="1tk6qn4b5r0or">
        {bubbles.map((bubble, index) => <Reveal key={bubble.text} delay={0.35 + index * 0.22} offset={10} data-id="element-395" data-mp="1ok2715eydpub" data-mpi={index}>
            <div className={bubble.self ? 'flex justify-end' : 'flex justify-start'} data-id="element-396" data-mp="1ohzcq96rpajs">
              <div className={`max-w-[88%] rounded-2xl px-4 py-3 ${bubble.self ? 'bg-brand text-ink-900' : 'border border-white/10 bg-ink-700 text-white/80'}`} data-id="element-397" data-mp="1kkthkcqy4e4k">
                <p className="text-sm leading-relaxed" data-id="element-398" data-mp="39wc58zutkw7e">{bubble.text}</p>
                <p className={`mt-1.5 text-[11px] tabular-nums ${bubble.self ? 'text-ink-900/60' : 'text-white/35'}`} data-id="element-399" data-mp="34y2488mez1dv">
                  {bubble.time}
                </p>
              </div>
            </div>
          </Reveal>)}
      </div>
    </VignetteFrame>;
}